// extracted by mini-css-extract-plugin
export default {"Pagination":"index__Pagination__GnFBb","Filters":"index__Filters__P3G2r","Zoom":"index__Zoom__M549k"};